{
    "image_upload_error": "Не вдалося завантажити зображення. Спробуйте оновити сторінку та виберіть зображення ще раз.",
    "search_placeholder": "Пошук фото й ілюстрацій",
    "search": "Знайти",
    "photo": "Зображення",
    "image_by": "від",
    "free_photos_from": "Безплатні стокові зображення з",
    "uploading": "Завантажується",
    "cancel": "Скасувати",
    "select": "Вибрати"
}
